import { CSSProperties } from 'react'
import { Player } from '../types'

interface CharityIconProps {
  player: Player
  url?: string
}

export const CharityIcon = ({ player, url }: CharityIconProps) => {
  const iconSize = url ? 45 : 30
  const iconUrl = `https://airtable.com/shrHkeLPxxelIyt4l?prefill_Request%20type=Update%20charity%20choice&hide_playerId=true&hide_Request%20type=true&prefill_playerId=${player.id}`

  const mainStyle: CSSProperties = {
    position: 'absolute',
    left: 10,
    top: 10,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: 45,
  }

  const imageStyle: CSSProperties = {
    marginBottom: 3,
    maxWidth: iconSize,
    maxHeight: iconSize,
    opacity: url ? 1 : 0.8,
  }

  return (
    <div style={mainStyle}>
      <a
        style={{ textDecoration: 'none' }}
        target="_blank"
        rel="noreferrer"
        href={iconUrl}
      >
        <div style={{ fontSize: 8, marginBottom: 5 }}>Your charity</div>
        <img style={imageStyle} src={url || 'questionMark.png'} />
      </a>
    </div>
  )
}
